<template>
    <v-container>
        <h1 class="titulo mb-3">Importação Política Vendas</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="form" @submit.prevent="importar">
                    <v-row>
                        <h1 class="titulo col-12 mb-3">Importação via CSV</h1>
                    </v-row>

                    <v-row>
                        <p class="col-12 text-center">Faça o upload de um arquivo em formato .CSV para importar dados de Aumento de Crédito e Diluição de Lance por grupo</p>
                    </v-row>
                    <v-row>
                        <v-col class="col-6 offset-3">
                            <v-file-input
                                    label="Upload de arquivo:"
                                    accept=".csv"
                                    dense
                                    outlined
                                    v-model="file"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <v-row class="justify-space-between">
                        <v-col style="vertical-align: middle;">
                            <v-btn @click="download" class="transition" color="primary" rounded>
                                <v-icon small style="margin-right: 8px"> cloud_download </v-icon>
                                Modelo do arquivo
                            </v-btn>
                        </v-col>
                        <v-col cols="3" style="vertical-align: middle;">
                            <v-btn class="transition" color="secondary" rounded @click="importar()">
                                <v-icon small style="margin-right: 8px"> cloud_upload </v-icon>
                                Importar Grupos
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <br />
                <v-divider />
                <br />
                <v-row>
                    <h1 class="titulo col-12 mb-3">Importação Manual</h1>
                </v-row>
                <v-row>
                    <v-col>
                        <Autocomplete label="Grupo:"
                                      id="FieldGrupo"
                                      :items="tipos_grupos"
                                      v-input-filter="[$filters.numeric]"
                                      v-model="cd_grupo"
                                      item-text="cd_grupo"
                                      type="number"
                                      item-value="cd_grupo"
                                      placeholder="Selecione o grupo"
                                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                      maxlength="8"
                                      class="col-md-4" />
                    </v-col>
                    <v-col>
                        <p>Diluição de Lance:</p>

                        <v-row class="justify-space-center">
                            <v-checkbox :disabled="!cd_grupo" v-model="ckb_lance_livre" label="Lance Livre" />
                            <MoneyTextField
                                    style="margin-left: 20px; margin-top: 0; margin-right: 20px; max-width: 250px"
                                    ref="FieldLanceLivre"
                                    :disabled="!ckb_lance_livre"
                                    outlined
                                    maxlength="18"
                                    v-model="lance_livre"
                                    :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }"
                                    maxvalue="100"
                            />
                        </v-row>
                        <v-row>
                            <v-checkbox :disabled="!cd_grupo" v-model="ckb_lance_fixo" label="Lance Fixo" />
                            <MoneyTextField
                                    style="margin-left: 25px; margin-top: 0; margin-right: 20px; max-width: 250px"
                                    ref="FieldLanceFixo"
                                    :disabled="!ckb_lance_fixo"
                                    outlined
                                    maxlength="5"
                                    v-model="lance_fixo"
                                    :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }"
                                    maxvalue="100"
                            />
                        </v-row>
                    </v-col>
                    <v-col>
                        <p>Aumento de Crédito:</p>
                        <v-switch :disabled="!cd_grupo" v-model="aumento_credito" label="Não/Sim" />
                    </v-col>
                </v-row>
                <v-row class="justify-end">
                    <v-col cols="3">
                        <v-btn class="transition" color="secondary" rounded type="submit" @click="salvar()">
                            Salvar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <div v-if="log">
            <h1 class="col-12 text-center" style="margin-top:25px;">Veja abaixo o log da importação</h1>
            <v-card class="card">
                <v-card-text>
                    <span style="white-space: pre-line"> {{ log }} </span>
                </v-card-text>
            </v-card>
        </div>
    </v-container>
</template>

<script>
  import { sleep, notification } from '@/plugins/helpers'
  import { MB } from '@/plugins/constants'
  import { isEmpty } from 'lodash'
  import { AlertTypes } from '@/plugins/alerts_types'

  export default {
    name: 'ImportaPoliticaVendas',
    data: () => ({
      ckb_lance_livre: false,
      ckb_lance_fixo: false,
      cd_grupo: '',
      lance_livre: '',
      lance_fixo: '',
      aumento_credito: false,
      file: null,
      log: '',
      url: null,
      tipos_grupos: []
    }),
    watch: {
      cd_grupo (v) {
        if (!isEmpty(v)) {
          this.$http.get('/painel/politica/grupo', { params: { cd_grupo: v } }).then(res => {
            if (res.data.length > 0) {
              this.lance_livre = res.data[0].dil_lance_livre
              this.lance_fixo = res.data[0].dil_lance_fixo
              this.aumento_credito = res.data[0].aumento_credito
              this.ckb_lance_livre = res.data[0].dil_lance_livre > 0
              this.ckb_lance_fixo = res.data[0].dil_lance_fixo > 0
            } else {
              this.lance_livre = ''
              this.lance_fixo = ''
              this.aumento_credito = false
              this.ckb_lance_livre = false
              this.ckb_lance_fixo = false
            }
          })
        } else {
          this.lance_livre = ''
          this.lance_fixo = ''
          this.aumento_credito = false
          this.ckb_lance_livre = false
          this.ckb_lance_fixo = false
        }
      },
      file (val) {
        if (val && val.size > 60 * MB) {
          notification('error', 'O arquivo enviado possui mais de 60MB, por favor, escolha um arquivo menor.')
          this.file = null
        }
      }
    },
    mounted () {
      this.$http.get('/link').then(res => {
        if (res.data) {
          this.url = res.data
        }
      })
      this.$http.get('/painel/politica/grupos').then(res => {
        if (res.data) {
          this.tipos_grupos = res.data.GruposDisponivel
        }
      })
    },
    methods: {
      salvar () {
        try {
          const form = this.$refs.form
          if (form.validate()) {
            if (this.cd_grupo) {
              this.$http.post('/painel/politica/inserir', {
                cd_grupo: this.cd_grupo,
                dil_lance_livre: this.ckb_lance_livre ? this.lance_livre : 0,
                dil_lance_fixo: this.ckb_lance_fixo ? this.lance_fixo : 0,
                aumento_credito: this.aumento_credito

              }).then(result => {
                if (result.data) {
                  notification(AlertTypes.SUCCESS, `Configuração realizada com sucesso para o grupo ${this.cd_grupo}`)
                  this.cd_grupo = ''
                  this.lance_livre = ''
                  this.lance_fixo = ''
                  this.aumento_credito = false
                  this.ckb_lance_livre = false
                  this.ckb_lance_fixo = false
                } else {
                  notification(AlertTypes.ERROR, `${result.data.msg_erro}`)
                }
              })
            } else {
              notification('warning', 'Campos obrigatórios não preenchidos!')
            }
          } else {
            form.resetValidation()
            sleep(100).then(() => form.validate())
          }
        } catch (e) {
          notification('error', e, 'Falha ao cadastrar nova política de vendas. Tente novamente mais tarde!!')
        }
      },
      importar () {
        let formData = new FormData()

        if (this.file) {
          formData.append('file', this.file)

          this.$http.post('/painel/politica/importar', formData)
            .then((res) => {
              if (res.data) {
                this.file = null
                this.log = res.data.saida
                if (!res.data.ok) {
                  this.log = res.data.saida.log
                  notification('error', res.data.msg_Erro)
                }
              }
            })
            .catch(e => {
              this.log = e
              notification('error', 'Não foi possível importar as políticas, veja abaixo o log de importação.')
            })
        }
      },
      download () {
        window.location = `${this.url}/exemplopolitica`
      }
    }
  }

</script>

<style scoped>

</style>
